module.exports = __webpack_public_path__ + "media/country_flags/br-7f0d5890.png";